// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-navBar[data-v-78ac7152] .action-item-notification {\n  display: none !important;\n}", ""]);
// Exports
module.exports = exports;
